import { API } from "./middleware";

export async function fetchCategoryOptions() {
  return API.get("/api/public/category/getOptions")
    .then((res) => res.data?.object || [])
    .catch((err) => {
      console.error("Lỗi khi load danh mục:", err);
      return [];
    });
}

export async function fetchProductsByCategory(categoryId, page = 0, size = 10, searchString = "") {
  return API.post("/api/public/template/searchTemplates", {
    categoryId,
    page,
    size,
    searchString,
    status: 1,
  })
    .then((res) => res.data?.object || { datas: [], totals: 0 })
    .catch((err) => {
      console.error("Lỗi khi lấy templates theo category:", err);
      return { datas: [], totals: 0 };
    });
}

export async function fetchTemplateById(templateId) {
  try {
    const res = await API.get(`/api/public/template/${templateId}`);
    return res.data?.object || null;
  } catch (err) {
    console.error("Lỗi khi lấy template theo ID:", err);
    return null;
  }
}

export async function fetchStickers(params = {}) {
  return API.post("/api/public/sticker/search", params)
    .then((res) => res.data?.object || { datas: [], totals: 0 })
    .catch((err) => {
      console.error("Lỗi khi lấy sticker:", err);
      return { datas: [], totals: 0 };
    });
}

export async function fetchFonts(params = {}) {
  return API.post("/api/public/font/search", {
    status: params.status ?? 1,
    ...params,
  })
    .then((res) => res.data?.object || { datas: [], totals: 0 })
    .catch((err) => {
      console.error("Lỗi khi lấy danh sách font:", err);
      return { datas: [], totals: 0 };
    });
}

export function getApiBaseUrl() {
  return (
    window.REACT_APP_API_URL || process.env.REACT_APP_BASE_URL_JAVA || "https://api-zumi.nst.com.vn" // fallback nếu không có
  );
}

export async function uploadTempImage(file) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${getApiBaseUrl()}/api/public/upload`, {
    method: "POST",
    body: formData,
  });

  const json = await res.json();

  if (json.status !== 200 || !json.object?.url) {
    throw new Error(json.message || "Upload thất bại");
  }

  return {
    ...json,
    fullUrl: `${getApiBaseUrl()}${json.object.url}`, // ✅ link hoàn chỉnh
  };
}

export function downloadByEncryptedId(encryptedId, type = "original") {
  return `${getApiBaseUrl()}/api/attachments/downloadByEncryptedId?encryptedId=${encryptedId}&type=${type}`;
}

export function downloadJsonByEncryptedId(encryptedId, type = "original") {
  return `${getApiBaseUrl()}/api/attachments/downloadJsonByEncryptedId?encryptedId=${encryptedId}&type=${type}`;
}

export async function uploadDesignAttachment(
  file,
  objectId = -1,
  objectType = 999,
  attachType = 1
) {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("objectId", objectId);
  formData.append("objectType", objectType);
  formData.append("attachType", attachType);

  const res = await API.post("/api/attachments/uploadFile", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // ✅ thêm header bắt buộc
    },
  });
  const result = res.data;

  return {
    ...result,
    encryptedId: result.encryptedBase64Id, // ✅ chuẩn hóa tên cho FE
    // imageUrl: downloadByEncryptedId(result.encryptedBase64Id), // ✅ tạo URL hiển thị ảnh nếu cần dùng ngay
  };
}

export async function uploadMultipleDesignAttachments({
  files = [],
  objectId = -1,
  objectType = 999,
  attachType = 1,
  isUpdate = false,
}) {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file); // ⚠️ key phải là `files` nếu backend dùng List<MultipartFile>
  });

  formData.append("objectId", objectId);
  formData.append("objectType", objectType);
  formData.append("attachType", attachType);
  formData.append("mode", isUpdate ? "update" : "create");

  const res = await API.post("/api/attachments/uploadMultipleFiles", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data.object || []; // nên là [{ encryptedBase64Id, fileName, ... }]
}

export async function fetchPreviewCombinedImage(files = [], isPreview = false) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("images", file); // ✅ đúng key backend yêu cầu
  });

  try {
    const res = await API.post(`/api/public/attachments/preview?isPreview=${isPreview}`, formData, {
      responseType: "blob", // ✅ nhận lại ảnh blob từ server
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data; // là blob
  } catch (err) {
    console.error("Lỗi khi gọi preview API:", err);
    throw err;
  }
}

export async function callRemoveBgApi(blobIn) {
  const formData = new FormData();
  formData.append("file", blobIn, "input.png");

  const response = await API.post("/api/public/remove-bg", formData, {
    responseType: "blob", // để trả về ảnh
    timeout: 300000, // 5 phút nếu ảnh lớn
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

export async function fetchTempDesignFromUrl(encodedId) {
  try {
    if (!encodedId) throw new Error("Không có encodedId để fetch thiết kế");

    const url = `${getApiBaseUrl()}/api/public/temp-json/${encodedId}`;
    const res = await API.get(url);

    if (!res || typeof res.status !== "number") {
      throw new Error("Phản hồi không hợp lệ từ server");
    }

    if (res.status !== 200 || !res.data) {
      throw new Error("Không tải được thiết kế tạm");
    }

    return res.data;
  } catch (err) {
    console.error("❌ Lỗi khi fetch temp json:", err);
    throw err;
  }
}
